import { format, addDays, endOfDay } from 'date-fns/esm';

function captureWarning(message, extra) {
  window.Raven.captureMessage(message, {
    extra,
    level: 'warning',
  });
}

export default angular
  .module('app.services.uya-text-helper', [])
  .service('UyaTextHelper', function($filter) {
    let self;
    let _identifiers = function(ids) {
      if (ids == null) {
        ids = [];
      }
      if (!ids.length) {
        return;
      }
      let text = '<br><br>';
      ids.forEach(item => (text += `${item.name}: ${item.value}<br>`));
      return text;
    };

    let _messages = {
      /**
       * Statuses of the UYA Move Item
       *
       *  Possible Statuses:
       *    - pending
       *    - unverified
       *    - cancelled
       *    - completed
       *
       * @type {Object}
       */
      status: {
        pending(item, date) {
          if (date < addDays(endOfDay(new Date()), 3)) {
            return `We'll submit your Updater notification to ${
              item.organization.name
            } \
within the next 2 business days.`;
          }

          return `We'll submit your Updater notification to ${
            item.organization.name
          } right \
before your move date, so it doesn't get there before you do.`;
        },

        unverified() {
          return `We need you to take a minute to verify your identity before we can process \
this Updater notification.`;
        },

        cancelled() {
          return 'This Updater notification has been cancelled.';
        },

        completed() {
          return 'This Updater notification has been completed.';
        },
      },

      /**
       * States of the UYA Move Item
       *
       *  Possible States:
       *    - undeliverable
       *    - ncoa
       *    - sent
       *
       * @type {Object}
       */
      state: {
        sent(item) {
          return `Sent on ${format(item.statusUpdatedAt, 'M/d/yyyy')} \
${_identifiers(item.identifiers) || ''}`;
        },

        ncoa(item) {
          return `Sent on ${format(item.statusUpdatedAt, 'M/d/yyyy')}<br><br> \
Please note that it can take 4-6 weeks for ${item.organization.name} to \
process this update.`;
        },

        ncoa_sent(item) {
          return `Sent on ${format(item.statusUpdatedAt, 'M/d/yyyy')}<br><br> \
Please note that it can take 4-6 weeks for ${item.organization.name} to \
process this update.`;
        },

        undeliverable(item) {
          return `Sent on ${format(item.statusUpdatedAt, 'M/d/yyyy')}<br><br> \
We sent your Updater notification to ${item.organization.name}, however, \
they were unable to process this request.  Please reach out to them directly \
to update your address.`;
        },
      },
    };

    return (self = {
      text(item, date) {
        const key = Array.from(Object.keys(_messages.status)).includes(
          item.status
        )
          ? 'status'
          : 'state';

        if (typeof _messages[key][item[key]] !== 'function') {
          // TODO: Remove when the source of this issue is resolved.
          captureWarning(
            'uya-text-helper: _messages[key][item[key]] is not a function',
            {
              key,
              item,
              date,
            }
          );
          return '';
        }

        return `<b>${item.organization.name}</b><br><br> \
${_messages[key][item[key]](item, date)}`;
      },

      plainText(item, date) {
        const key = Array.from(Object.keys(_messages.status)).includes(
          item.status
        )
          ? 'status'
          : 'state';

        if (typeof _messages[key][item[key]] !== 'function') {
          // TODO: Remove when the source of this issue is resolved.
          captureWarning(
            'uya-text-helper: _messages[key][item[key]] is not a function',
            {
              key,
              item,
              date,
            }
          );
          return '';
        }

        return _messages[key][item[key]](item, date);
      },

      iconText(state) {
        if (state == null) {
          state = 'undefined';
        }
        return (
          {
            ncoa_sent: 'Sent',
            ncoa: 'Sent',
            undeliverable: 'Action Required',
            undefined: 'Action Required',
          }[state] || $filter('inflector')(state)
        );
      },
    });
  });
